/** Represents the available sort keys for when reading the conversations. */
export const readConversationSortKeys = [
    'created_at',
    'last_message_created_at',
    'updated_at',
];
